import { X } from "lucide-react";
import { toast } from "sonner";
import { usePoll } from "@/hooks/usePoll";
import { api, errMsg, get } from "@/lib/api";
import { fmtTime, slug } from "@/lib/format";

export const SubscriptionsPanel = ({ onOpen }) => {
  const { data, refresh } = usePoll(() => get("/subscriptions"), 3000, []);
  const drop = async (it) => {
    try {
      await api.post(`/symbols/${it.instrument_token}/unsubscribe`);
      toast.success(`Released ${it.key}`);
      refresh();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div data-testid="subscriptions-panel" className="space-y-3 p-3">
      <div className="flex flex-wrap gap-2">
        {data && Object.entries(data.caps).map(([cls, cap]) => (
          <div key={cls} data-testid={`sub-count-${cls}`} className="rounded border border-slate-800 bg-slate-950/40 px-3 py-1.5 font-mono text-[11px]">
            <span className="uppercase text-slate-500">{cls}</span>{" "}
            <span className="text-slate-100">{data.by_class[cls] || 0}</span><span className="text-slate-600">/{cap}</span>
          </div>
        ))}
        {data && (
          <div className="rounded border border-slate-800 bg-slate-950/40 px-3 py-1.5 font-mono text-[11px]">
            TOTAL <span className="text-slate-100">{data.total}</span><span className="text-slate-600">/{data.max_total}</span> · on-demand TTL {data.on_demand_ttl_minutes}m
          </div>
        )}
      </div>
      <div className="scroll-thin max-h-[520px] overflow-auto rounded border border-slate-800">
        <table className="w-full min-w-[600px] font-mono text-xs">
          <thead className="sticky top-0 bg-slate-900 text-[10px] uppercase tracking-wider text-slate-500">
            <tr>{["Instrument", "Class", "Reasons", "Since", "Last access", ""].map((h) => <th key={h} className="px-3 py-1.5 text-left">{h}</th>)}</tr>
          </thead>
          <tbody>
            {data?.items.map((it) => (
              <tr key={it.instrument_token} data-testid={`sub-row-${slug(it.key)}`} className="border-t border-slate-800/60 hover:bg-slate-800/30">
                <td className="cursor-pointer px-3 py-1.5 text-slate-200 hover:text-cyan-300" onClick={() => onOpen({ instrument_token: it.instrument_token, tradingsymbol: it.key.split(":")[1], exchange: it.key.split(":")[0], cls: it.cls })}>{it.key}</td>
                <td className="px-3 py-1.5 text-slate-500">{it.cls}</td>
                <td className="px-3 py-1.5 text-slate-400">{it.reasons.join(", ")}</td>
                <td className="px-3 py-1.5 text-slate-500">{fmtTime(it.subscribed_at)}</td>
                <td className="px-3 py-1.5 text-slate-500">{fmtTime(it.last_access)}</td>
                <td className="px-3 py-1.5 text-right">
                  {it.reasons.some((r) => r === "on_demand" || r === "option_chain") && (
                    <button data-testid={`sub-release-${slug(it.key)}`} onClick={() => drop(it)} className="text-slate-500 transition-colors hover:text-rose-400"><X className="h-3.5 w-3.5" /></button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
